import { render } from "./UnauthBg.vue?vue&type=template&id=916031fe&ts=true"
import script from "./UnauthBg.vue?vue&type=script&lang=ts"
export * from "./UnauthBg.vue?vue&type=script&lang=ts"

import "./UnauthBg.vue?vue&type=style&index=0&id=916031fe&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__